import http from './http'

class Import {
  assignors (payload) {
    return http.post('/import_assignors', payload)
  }

  templates () {
    return http.get('/import_templates')
  }

  findTemplate (payload) {
    return http.post('/import_templates/get_templates', { ...payload })
  }

  invoices () {
    return http.get('/import_invoices')
  }
}

export default new Import()



// WEBPACK FOOTER //
// ./src/services/import.js